module.exports = __webpack_public_path__ + "static/6cf9398e7e0e602cf627e661f305fb3eff31f6a7b269025e07c24d16ac6dc9c7-d04340bc2e22c446bd07bad8ca7c4d17.jpeg";